import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { withFirebaseAuth } from '../auth/withFirebaseAuth';
import './css/Tracker.css';
import './css/LogBookAdmin.css';
import { Log } from "../class/Log";
import { LookupItem } from './../class/LookupItem';
import UserAircraftPopup from "./popup/UserAircraftPopup";
import UserAirportPopup from "./popup/UserAirportPopup";
import * as actionCreator from '../actions/actions';
import { MyLookup } from '../class/Enums';
// @ts-ignore
import AircraftTypeImg from '../images/diamond.jpg'; import WorldImg from '../images/world.jpg'; import RegisterImg from '../images/registerAircraft.jpg';
import { UserAircraft } from '../class/UserAircraft';
import { UserAirport } from '../class/UserAirport';
import ConfirmPopup from './popup/ConfirmPopup';
import Badge from 'react-bootstrap/Badge';


const yearList: LookupItem[] = [];
const currentYear = new Date().getFullYear();
for (let i = currentYear; i > currentYear - 10; i--) {
    let item = { label: (i).toString(), value: i }
    yearList.push(item);
}

interface Props {
    aircraftModelList: any;
    userAircraftList: Array<UserAircraft>;
    userAirportList: Array<UserAirport>;
    firebaseAuth: any;
    
    getLookupList(): void;
    getUserAircraftList(token: any): void;
    getUserAirportList(token: any): void;
    updateUserAircraft(token: any, userAircraft: any): void;
    deleteUserAircraft(token: any, userAircraft: any): void;
    updateUserAirport(token: any, userAirport: any): void;
    deleteUserAirport(token: any, userAirport: any): void;
}

interface State {
    showAircraftPopup: boolean;
    showAirportPopup: boolean;
    showConfirmPopup: boolean;
    popupTitle: string;
    token: any;
    selectedUserAircraft: UserAircraft;
    selectedUserAirport: UserAirport;
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        aircraftModelList: state.lookupList[MyLookup.AircraftList],
        airportList: state.lookupList[MyLookup.AirportList],
        userAircraftList: state.userAircraftList,
        userAirportList: state.userAirportList,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        getLookupList: () => dispatch<any>(actionCreator.default.lookup.getLookupList()),
        getUserAircraftList: (token: any) => dispatch<any>(actionCreator.default.userAircraft.getUserAircraftList(token)),
        getUserAirportList: (token: any) => dispatch<any>(actionCreator.default.userAirport.getUserAirportList(token)),
        updateUserAircraft: (token: any, userAircraft: any) => dispatch<any>(actionCreator.default.userAircraft.updateUserAircraft(token, userAircraft)),
        deleteUserAircraft: (token: any, userAircraft: any) => dispatch<any>(actionCreator.default.userAircraft.deleteUserAircraft(token, userAircraft)),
        updateUserAirport: (token: any, userAirport: any) => dispatch<any>(actionCreator.default.userAirport.updateUserAirport(token, userAirport)),
        deleteUserAirport: (token: any, userAirport: any) => dispatch<any>(actionCreator.default.userAirport.deleteUserAirport(token, userAirport)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFirebaseAuth(class LogBookAdmin extends React.Component<Props, State>{
    static displayName = LogBookAdmin.name;

    constructor(props: any) {
        super(props);

        this.state = {
            token: null,
            popupTitle: "",
            showAircraftPopup: false,
            showAirportPopup: false,
            showConfirmPopup: false,
            selectedUserAircraft: {},
            selectedUserAirport: {},
        };
    };

    async componentDidMount() {
        try {
            const token = await this.props.firebaseAuth.getAccessToken();
            if (token) {
                this.props.getLookupList();
                this.props.getUserAircraftList(token);
                this.props.getUserAirportList(token);
                this.setState({
                    token: token
                })
            }
        } catch (err) {
            console.error('Error getting token:', err);
        }
    }

    handleAddAircraft = () => {
        this.setState({
            popupTitle: "Add Aircraft",
            showAircraftPopup: true
        });
    }

    handleCloseAircraftPopup = () => {
        this.setState({
            showAircraftPopup: false,
        });
    }

    handleUserAircraftFavorit = (userAircraft: UserAircraft) => {
        this.props.updateUserAircraft(this.state.token, userAircraft);
    }

    handleUserAirportFavorit = (userAirport: UserAirport) => {
        this.props.updateUserAirport(this.state.token, userAirport);
    }

    handleEditAircraft = (userAircraft: UserAircraft) => {
        this.setState({
            popupTitle: "Edit Aircraft",
            selectedUserAircraft: userAircraft,
            showAircraftPopup: true
        });
    }

    handleDeleteUserAircraft = (userAircraft: any) => {
        this.setState({
            selectedUserAircraft: userAircraft,
            showConfirmPopup: true
        });
    }

    handleConfirmDeleteUserAircraft = (confirmDelete: boolean) => {
        if (confirmDelete) {
            this.setState({ showConfirmPopup: false });
            this.props.deleteUserAircraft(this.state.token, this.state.selectedUserAircraft.userAircraftId);
        }
        else {
            this.setState({
                showConfirmPopup: false,
            });
        }
    }

    handleAddAirport = () => {
        this.setState({
            popupTitle: "Add Airport",
            showAirportPopup: true
        });
    }

    handleCloseAirportPopup = () => {
        this.setState({
            showAirportPopup: false,
        });
    }

    handleDeleteUserAirport = (userAirport: any) => {
        this.setState({
            selectedUserAirport: userAirport,
            showConfirmPopup: true
        });
    }

    handleConfirmDeleteUserAirport = (confirmDelete: boolean) => {
        if (confirmDelete) {
            this.setState({ showConfirmPopup: false });

            this.props.deleteUserAirport(this.state.token, this.state.selectedUserAirport.userAirportId);
        }
        else {
            this.setState({
                showConfirmPopup: false,
            });
        }
    }

    render() {
        if (!this.props.firebaseAuth?.isAuthenticated) return <div>Loading...</div>;

        let myAircraftList = this.props.userAircraftList.map((item, index) => (
            <tr key={index}>
                <td className="d-none d-lg-table-cell">
                    <div className="aircraft-type">
                        <i className="fas fa-plane-departure"></i>
                        {item.aircraftModel?.aircraftModelName}
                    </div>
                </td>
                <td>
                    <div className="registration-info">
                        <span className="registration">{item.aircraftRegistration}</span>
                        {item.nbrLogs !== undefined && item.nbrLogs > 0 && (
                            <Badge bg="primary" className="logs-badge">{item.nbrLogs} logs</Badge>
                        )}
                    </div>
                </td>
                <td>
                    <div className="action-buttons">
                        <button 
                            className="action-btn favorite-btn"
                            onClick={() => this.handleUserAircraftFavorit(item)}
                            title={item.isAircraftFavorit ? "Remove from favorites" : "Add to favorites"}
                        >
                            <i className={item.isAircraftFavorit ? "fas fa-heart" : "far fa-heart"}></i>
                        </button>
                        <button 
                            className="action-btn edit-btn"
                            onClick={() => this.handleEditAircraft(item)}
                            title="Edit aircraft"
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                        {item.nbrLogs !== undefined && item.nbrLogs == 0 && (
                            <button 
                                className="action-btn delete-btn"
                                onClick={() => this.handleDeleteUserAircraft(item)}
                                title="Delete aircraft"
                            >
                                <i className="fas fa-trash"></i>
                            </button>
                        )}
                    </div>
                </td>
            </tr>)
        )

        let myAirporttList = this.props.userAirportList.map((item, index) => (
            <tr key={index}>
                <td>
                    <div className="airport-info">
                        <i className="fas fa-map-marker-alt"></i>
                        <span className="airport-name">{item.airport?.airportName}</span>
                        {item.nbrLogs !== undefined && item.nbrLogs > 0 && (
                            <Badge bg="success" className="logs-badge">{item.nbrLogs} visits</Badge>
                        )}
                    </div>
                </td>
                <td>
                    <div className="airport-code">
                        <span className="code">{item.airport?.airportCode}</span>
                    </div>
                </td>
                <td>
                    <div className="action-buttons">
                        <button 
                            className="action-btn favorite-btn"
                            onClick={() => this.handleUserAirportFavorit(item)}
                            title={item.isAirportFavorit ? "Remove from favorites" : "Add to favorites"}
                        >
                            <i className={item.isAirportFavorit ? "fas fa-heart" : "far fa-heart"}></i>
                        </button>
                        <button 
                            className="action-btn delete-btn"
                            onClick={() => this.handleDeleteUserAirport(item)}
                            title="Remove airport"
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>)
        )

        return (
            <div className="logbook-admin-container">
                <div className="admin-grid">
                    <div className="admin-card aircraft-card">
                        <div className="card-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <i className="fas fa-plane"></i>
                                    <h3>My Aircraft</h3>
                                    <span className="item-count">{this.props.userAircraftList.length}</span>
                                </div>
                                <button className="add-btn" onClick={this.handleAddAircraft}>
                                    <i className="fas fa-plus"></i>
                                    Add Aircraft
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-container">
                                <table className="modern-table">
                                    <thead>
                                        <tr>
                                            <th className="d-none d-lg-table-cell">Type</th>
                                            <th>Registration</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {myAircraftList}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="admin-card airports-card">
                        <div className="card-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <i className="fas fa-map-marker-alt"></i>
                                    <h3>My Airports</h3>
                                    <span className="item-count">{this.props.userAirportList.length}</span>
                                </div>
                                <button className="add-btn" onClick={this.handleAddAirport}>
                                    <i className="fas fa-plus"></i>
                                    Add Airport
                                </button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-container">
                                <table className="modern-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>ICAO Code</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {myAirporttList}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <LogBookAdminPopup show={this.state.showAircraftPopup} popupTitle={this.state.popupTitle} log={this.state.selectedAircraftList} hide={this.handleCloseLogPopup} token={this.state.token} /> */}
                <UserAircraftPopup show={this.state.showAircraftPopup} popupTitle={this.state.popupTitle} token={this.state.token} hide={this.handleCloseAircraftPopup} userAircraftList={this.props.userAircraftList} userAircraft={this.state.selectedUserAircraft} />
                <UserAirportPopup show={this.state.showAirportPopup} popupTitle={this.state.popupTitle} token={this.state.token} hide={this.handleCloseAirportPopup} userAirportList={this.props.userAirportList} userAirport={this.state.selectedUserAirport} />
                <ConfirmPopup show={this.state.showConfirmPopup} hide={this.handleConfirmDeleteUserAircraft} title="Delete User Aircraft" content="Do you really want to delete this aircraft ?" />
                <ConfirmPopup show={this.state.showConfirmPopup} hide={this.handleConfirmDeleteUserAirport} title="Remove User Aircraft" content="Do you really want to remove this Airport ?" />
            </div>)
    }
}))


{/* <Select id="logBookAircraftModel" onChange={this.handleChangeYear} options={yearList} value={this.state.selectedYear}
styles={{
    control: (baseStyles) => ({
        ...baseStyles,
        padding: '0px',
        minHeight: '32px', // Ensure minimum height to avoid clipping content
        backgroundColor: '#ccd2d8',
    }),
    option: (provided) => ({
        ...provided,
        color: 'black', // or any other color that provides good contrast
    }),
    // Optionally, you can add more styling for other components like the menu, option, etc.
}}
theme={(theme) => ({
    ...theme,
    borderRadius: 5,
    colors: {
        ...theme.colors,
        primary75: 'danger'
    },
})}
/> */}